<template>
  <div class="dataCenterNode" v-show="showDataCenterNode">
    <div class="content d-flex justify-content-between">
      <div class="leftBlock">
        <div class="map">
          <div id="map-container"></div>

          <div
            v-for="(d, index) in items"
            :key="'D' + index"
            class="mapMarker"
            :class="index === showIndex ? 'mapMarker-selected' : ''"
            :data-latitude="d.geo_latitude"
            :data-longitude="d.geo_longitude"
            :ref="`mapMarker_${index}`"
            @click="changeDataCenter(index, d.id)"
          >
            {{ index + 1 }}
          </div>
        </div>

        <div class="datacenter" v-if="items && items.length > 0">
          <div class="title">{{ items[showIndex].name }}</div>
          <div class="country">
            {{
              items[showIndex].country && items[showIndex].country.data
                ? items[showIndex].country.data.name
                : ''
            }}
            {{ items[showIndex].city ? ', ' + items[showIndex].city : '' }}
          </div>
          <div class="description" v-if="items[showIndex].description">
            {{ items[showIndex].description }}
          </div>

          <div class="properties">
            <div
              class="property d-flex align-items-center"
              v-if="items[showIndex].electricity"
            >
              <div class="key">{{ $t('global.electricity') }}</div>
              <div class="value">{{ items[showIndex].electricity }}</div>
            </div>
            <div
              class="property d-flex align-items-center"
              v-if="items[showIndex].generators"
            >
              <div class="key">{{ $t('global.generators') }}</div>
              <div class="value">{{ items[showIndex].generators }}</div>
            </div>
            <div
              class="property d-flex align-items-center"
              v-if="items[showIndex].tier_level"
            >
              <div class="key">{{ $t('global.tierLevel') }}</div>
              <div class="value">{{ items[showIndex].tier_level }}</div>
            </div>
            <div
              class="property d-flex align-items-center"
              v-if="items[showIndex].is_edge"
            >
              <div class="key">{{ $t('global.isEdge') }}</div>
              <div class="value">{{ items[showIndex].is_edge }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightBlock">
        <div class="header d-flex justify-content-between align-items-center">
          <div class="title">
            {{ $t('datacenter.nodes') }}
          </div>
          <div class="close" @click="close">
            <a href="#" class="d-flex btn btn-xs btn-light p-2 rounded-sm">
              <i class="far fa-times-circle p-0"></i>
            </a>
          </div>
        </div>

        <CardLoader v-if="nodeLoading">
          <rect x="0" y="4" width="400" height="12" rx="3" />
          <rect x="0" y="24" width="150" height="12" rx="3" />
          <rect x="0" y="56" width="400" height="12" rx="3" />
          <rect x="0" y="76" width="370" height="12" rx="3" />
          <rect x="0" y="96" width="178" height="12" rx="3" />
        </CardLoader>
        <div v-else class="card" v-for="(node, index) in nodes" :key="index">
          <div class="title">
            {{ node.name }}
          </div>
          <div class="description">{{ node.description }}</div>
          <div class="dc-node-select-icons" v-if="node.features">
            <div
              class="icon-wrapper"
              v-for="(item, index) in node.features.split(',')"
              :key="`icon-wrapper-${index}`"
              v-html="$options.filters.iconFilter(item)"
            ></div>
          </div>
          <b-button
            type="submit"
            class="w-100 rounded-sm"
            variant="primary"
            @click="nodeSelect(node)"
            >{{ $t('global.select') }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service'
import EventBus from '@/event-bus'
import mapboxgl from 'mapbox-gl'
import JwtService from '@/core/services/jwt.service'

export default {
  name: 'DataCenterNodes',
  data() {
    return {
      showDataCenterNode: false,
      showMap: false,
      map: '',
      items: [],
      showIndex: 0,
      showMarker: false,
      nodes: [],
      nodeLoading: true,
    }
  },
  mounted() {
    EventBus.$on(`changeVisibilityDataCenterNode`, this.listener)
  },
  beforeDestroy() {
    EventBus.$off(`changeVisibilityDataCenterNode`, this.listener)
  },
  methods: {
    listener(payload) {
      this.loadMapComponent()
      this.showDataCenterNode = payload
    },
    nodeSelect(node) {
      JwtService.setSelectedDataCenterNode(node)
      EventBus.$emit('nodeSelect', node.name)

      this.close()
      this.redirectAfterNodeChange()
    },
    redirectAfterNodeChange() {
      let current = this.$router.currentRoute.fullPath.split('/')
      if (current.length > 3) {
        this.$router.push(`/${current[1]}/${current[2]}`)
      } else {
        this.$router.go(0)
      }
    },
    close() {
      this.showDataCenterNode = false
      EventBus.$emit('dataCenterNodeClose')
    },
    loadMapComponent() {
      if (!this.showMap) {
        mapboxgl.accessToken =
          // 'pk.eyJ1IjoiYnVyYWtrYXNpa2NpIiwiYSI6ImNsZ2Y0dWkyajAwejczZGxjZ3pmdXcyMGYifQ.n8jzE0kmeXsMUHrrH9Fcsw'
          'pk.eyJ1IjoicGx1c2Nsb3VkczIiLCJhIjoiY2szZm9ibzF4MDZnajNwcnowNWNvemxocyJ9.l67c2UvyWeQCgIvvntB6Ig'

        this.map = new mapboxgl.Map({
          container: 'map-container',
          style: 'mapbox://styles/mapbox/light-v10',
          // style: 'mapbox://styles/mapbox/dark-v10',
          center: [34, 39], // starting position [lng, lat]
          zoom: 5, // starting zoom
          interactive: true,
          attributionControl: false,
        })

        setTimeout(() => {
          this.map.resize()
        }, 20)
        this.showMap = true
        this.getItems()
      } else {
        setTimeout(() => {
          this.map.resize()
        }, 20)
      }
    },
    getItems() {
      ApiService.get(
        `iaas/datacenters?fields=electricity,generators,tier_level&orderBy=position|ASC`
      )
        .then((res) => {
          this.items = res.data.data
          if (this.items.length > 0) {
            this.getNodes(this.items[0].id)
            setTimeout(() => {
              for (let index = 0; index < this.items.length; index++) {
                if (this.$refs['mapMarker_' + index]) {
                  let el = this.$refs['mapMarker_' + index][0]
                  new mapboxgl.Marker(el)
                    .setLngLat([
                      el.getAttribute('data-longitude'),
                      el.getAttribute('data-latitude'),
                    ])
                    .addTo(this.map)
                }
              }
              this.showMarker = true
            }, 50)
          }
        })
        .catch((err) => {
          this.showMarker = true
        })
    },
    changeDataCenter(index, id) {
      this.showIndex = index
      this.nodeLoading = true
      this.nodes = []
      this.getNodes(id)
    },
    getNodes(id) {
      ApiService.get(
        `iaas/datacenter-nodes?datacenter=${id}&orderBy=position|ASC&locale=tr`
      )
        .then((res) => {
          this.nodes = res.data.data
        })
        .finally(() => {
          this.nodeLoading = false
        })
    },
  },
  filters: {
    iconFilter(icon) {
      if (icon) {
        let iconData = icon.split(':')

        if (iconData[0].trim() == 'intelxeon') {
          return `
            <i class="fal fa-microchip"></i>
            <span>${iconData[1].trim()}<span>
          `
        }
        if (iconData[0].trim() == 'network') {
          return `
            <i class="fal fa-ethernet"></i>
            <span>${iconData[1].trim()}<span>
          `
        }
        if (iconData[0].trim() == 'storage') {
          return `
            <i class="fal fa-hdd"></i>
            <span>${iconData[1].trim()}<span>
          `
        }
      }

      return icon
    },
  },
}
</script>

<style lang="scss" scoped>
.dataCenterNode {
  position: relative;
  z-index: 96;
  height: 0px;
  .content {
    margin: 10px 30px 0px;
    padding: 0;
    background: #ffffff;
    box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.15);
    border-radius: 12px;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #8a94a6;
    .leftBlock {
      width: calc(100% - 200px);
      box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.15);
      border-radius: 12px;
      .map {
        position: sticky;
        overflow: hidden;
      }
      #map-container {
        width: 100%;
        height: 500px;
      }
      .map-wrapper {
        position: relative;
        width: 100%;
        height: 500px;
      }
      .datacenter {
        margin: 20px;
        .title {
          font-weight: 600;
          font-size: 24px;
          line-height: 50px;
          color: #0a1f44;
        }
        .country {
          font-weight: normal;
          font-size: 16px;
          line-height: 34px;
          color: #758196;
          margin-bottom: 10px;
        }
        .description {
          font-weight: normal;
          font-size: 16px;
          line-height: 22px;
          color: #8a94a6;
        }
        .properties {
          margin-top: 20px;
          .property {
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: 0px;
            }
            .key {
              width: 120px;
              font-weight: 600;
              font-size: 16px;
              line-height: 0px;
              color: #0a1f44;
            }
            .value {
              font-weight: normal;
              font-size: 16px;
              line-height: 22px;
              color: #8a94a6;
            }
          }
        }
      }
    }
    .rightBlock {
      width: 200px;
      margin: 10px 20px;
      .header {
        .title {
          font-weight: 600;
          font-size: 24px;
          line-height: 50px;
          color: #0a1f44;
        }
        .close {
          opacity: 1;
          i {
            color: #f64e60 !important;
            font-size: 15px;
          }
        }
      }
      .card {
        background: #ffffff;
        border: 1px solid #ecf0f3;
        box-sizing: border-box;
        border-radius: 4px;
        padding: 20px;
        margin-bottom: 20px;
        .title {
          font-weight: 500;
          font-size: 13px;
          line-height: 19px;
          color: #464e5f;
          margin-bottom: 5px;
        }
        .description {
          font-weight: normal;
          font-size: 12px;
          line-height: 15px;
          color: #8a94a6;
          margin-bottom: 5px;
        }
        &:last-child {
          // border: 1px solid #ffffff;
          margin-bottom: 0px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.mapMarker {
  background-color: #ffffff;
  border: 1px solid #e5eaee;
  color: #00baf2;
  font-weight: 500;
  width: 25px;
  height: 25px;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  border-radius: 100px;
  cursor: pointer;
  z-index: 99;
  padding-top: 2px;
}
.mapMarker-selected {
  background-color: #00baf2 !important;
  border: 1px solid #ffffff !important;
  color: #ffffff !important;
  z-index: 100;
}

.dc-node-select-icons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;

  .icon-wrapper {
    border: 1px solid #eee5ff;
    border-radius: 4px;
    padding: 10px;
    text-align: center;
    flex: 1;

    i {
      display: block;
      font-size: 23px;
      line-height: 23px;
      color: #00baf2;
      margin-bottom: 10px;
    }

    span {
      display: block;
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      color: #464e5f;
    }
  }
}
</style>
